export default __webpack_public_path__ + "static/media/arrow-up.08210a96.svg";